import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import { createStore } from 'vuex'

import ConfigureIdentifiersInfoStore from './modules/ConfigureIdentifiersInfoStore'
/* import ConfigureImportEventsListStore from './modules/ConfigureImportEventsListStore'
import ConfigureNodeEventInfoStore from './modules/ConfigureNodeEventInfoStore'
import ConfigureNodeEvents from './modules/ConfigureNodeEvents'
import ConnectorStore from './modules/ConnectorStore' */
import DesignTestDataStore from './modules/DesignTestDataStore'
import ExtensionDataStore from './modules/ExtensionDataStore'
import IdentifiersStore from './modules/IdentifiersStore'
/* import RelationsBuilder from './modules/RelationsBuilder' */
import SensorElementsStore from './modules/SensorElementsStore'
import * as SourceDestinationStore from './modules/SourceDestinationStore'
import TestDataGeneratorStore from './modules/TestDataGeneratorStore'
import TestDataJsonPreparator from './modules/TestDataJsonPreparator'
import UserStore from './modules/user'

export default createStore({
  modules: {
    ConfigureIdentifiersInfoStore,
    /* ConfigureImportEventsListStore,
    ConfigureNodeEventInfoStore,
    ConfigureNodeEvents,
    ConnectorStore, */
    DesignTestDataStore,
    ExtensionDataStore,
    IdentifiersStore,
    /* RelationsBuilder, */
    SensorElementsStore,
    SourceDestinationStore,
    TestDataGeneratorStore,
    TestDataJsonPreparator,
    UserStore
  },
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    isTransparent: "",
    isRTL: false,
    color: "",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    navbarFixed:
      "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
    bootstrap,
    nodeModal: false,
    nodeArray: [],
    currentNode: ''
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.isTransparent = payload;
    },
    cardBackground(state, payload) {
      state.color = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    toggleEveryDisplay(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    toggleHideConfig(state) {
      state.hideConfigButton = !state.hideConfigButton;
    },
    showNodeModal(state) {
      state.nodeModal = true;
    },
    hideNodeModal(state) {
      state.nodeModal = false;
    },
    populateCurrentNode(state, node) {
      state.currentNode = node;
    },
    populateNodeInfo(state, nodeObj) {
      nodeObj.node = state.currentNode;
      state.nodeArray.push(nodeObj);
    },
    setShowSidenav(state, val) { state.showSidenav = !!val; }, 
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    setCardBackground({ commit }, payload) {
      commit("cardBackground", payload);
    },
  },
  getters: {},
});
